<template>
  <div v-if="menu.length" class="nav">
    <!-- <v-menu top close-on-click offset-y
      :close-on-content-click="closeOnContentClick"
    > -->
      <!-- <template v-slot:activator="{ on, attrs }"> -->
          <!-- v-bind="attrs" -->
          <!-- v-on="on" -->
      <template>
        <v-btn
          large
          icon
          @click="open = true"
          
          :style="{ color: btnBgColor }"
        >
          <img width="24" v-if="imgSrc" :src="imgSrc" alt="Menu">
          <svg width="24" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.10815 1c-.45876 0-.89872.16857-1.22311.46863-.32438.30006-.50662.70702-.50662 1.13137s.18224.83131.50662 1.13137c.32439.30006.76435.46863 1.22311.46863H22.7117c.4588 0 .8988-.16857 1.2231-.46863.3244-.30006.5067-.70702.5067-1.13137s-.1823-.83131-.5067-1.13137C23.6105 1.16857 23.1705 1 22.7117 1H3.10815zm0 6.4c-.45876 0-.89872.16857-1.22311.46863-.32438.30006-.50662.70702-.50662 1.13137s.18224.83131.50662 1.1314c.32439.3.76435.4686 1.22311.4686H22.7117c.4588 0 .8988-.1686 1.2231-.4686.3244-.30009.5067-.70705.5067-1.1314s-.1823-.83131-.5067-1.13137C23.6105 7.56857 23.1705 7.4 22.7117 7.4H3.10815zm0 6.4c-.45876 0-.89872.1686-1.22311.4686-.32438.3001-.50662.7071-.50662 1.1314s.18224.8313.50662 1.1314c.32439.3.76435.4686 1.22311.4686H22.7117c.4588 0 .8988-.1686 1.2231-.4686.3244-.3001.5067-.7071.5067-1.1314s-.1823-.8313-.5067-1.1314c-.3243-.3-.7643-.4686-1.2231-.4686H3.10815z" :fill='btnBgColor' stroke="#fff" stroke-miterlimit="10"/></svg>
          <!-- <v-icon v-else :style="{ color: btnBgColor }">
            {{ innerIconMenu }}
          </v-icon> -->
        </v-btn>
      </template>

      <Navigation  
        transition="scale-transition"
        v-if="open"
        :menu="menu" 
        @click="open = false" 
        :style="{ color: defaultFontColor, backgroundColor: btnBgColor }"
         />
        <!-- :class="{'close': !open, 'open': open}" -->
        <!-- :menu="menu" @click="isShown = false" :style="{ color: defaultFontColor, backgroundColor: btnBgColor }" -->
    <!-- </v-menu> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Navigation from './Navigation';
// import { mdiViewSequential } from '@mdi/js';
// import { innerIconMenu } from '../../../assets/icons';

export default {
  name: 'Nav',
  data() {
    return {
      // mdiViewSequential
      // innerIconMenu
      closeOnContentClick: true,
      open: false
    };
  },
  components: {
    Navigation,
  },
  computed: {
    ...mapGetters({
      persistenceMenu: 'theme/persistenceMenu',
    }),
    menu() {
      return this.persistenceMenu?.menu || [];
    },
    defaultFontColor() {
      return this.$store.getters['theme/theme'].common?.fontColor;
    },
    btnBgColor() {
      return this.$store.getters['theme/btnBgColor'];
    },
    imgSrc() {
      return this.$store.getters['theme/theme']?.config?.perMenuImg;
    }
  },
};
</script>

<style lang="scss" scoped>
.nav {
  position: relative;
  width: 36px;
  height: 36px;
  justify-content: center;
}

.nav-actions {
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-100%);

  ul {
    margin: 0;
    padding: 0;

    li {
      list-style-type: none;
    }
  }
}

</style>
